import type {
  RepeatableDefinition,
  SpecializationDefinition,
  TechnologyDefinition,
  TechnologyEffect,
} from "./types.js";

export const unlock = (...targets: string[]): TechnologyEffect => ({ kind: "unlock", targets });
export const multiply = (factor: string, ...targets: string[]): TechnologyEffect => ({
  kind: "multiply",
  factor,
  targets,
});

export function tech<const Id extends string>(
  id: Id,
  name: string,
  prerequisite: string | null,
  rpCost: number,
  durationSeconds: number,
  effect: TechnologyEffect,
): TechnologyDefinition & { readonly id: Id } {
  return { id, name, prerequisite, rpCost, durationSeconds, effect };
}

export function specialization<const Id extends string>(
  id: Id,
  name: string,
  branch: SpecializationDefinition["branch"],
  prerequisites: readonly string[],
  rpCost: number,
  durationSeconds: number,
  effect: TechnologyEffect,
): SpecializationDefinition & { readonly id: Id } {
  return { id, name, branch, prerequisites, rpCost, durationSeconds, effect };
}

export function repeatable<const Id extends string>(
  id: Id,
  name: string,
  targets: readonly string[],
): RepeatableDefinition & { readonly id: Id } {
  return {
    id,
    name,
    prerequisite: "factory-works",
    baseRpCost: 1000,
    costGrowth: "1.8",
    durationSeconds: 60,
    factorPerLevel: "1.10",
    targets,
  };
}
